import * as angular from 'angular';
import * as _ from 'lodash';

import { IStoreService } from '../../services';
import { ComponentDefinition } from '../../models';
import { StoreElement } from '../../stateManagement';

class AlarmCategoriesSelector implements angular.IComponentController {
    categories: string[];
    model: string[];
    disabled: boolean;
    private _unsubscribe: Function;

    static $inject = ['storeService'];

    constructor(private _storeService: IStoreService) {
    }

    $onInit() {
        this.initStore();
        if (!this.model) {
            this.model = [];
        }
    }

    $onDestroy() {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }

    initStore() {
        this._unsubscribe = this._storeService.register(
            store => {
                this.categories = _.values<string>(store.alarmCategories.dictionary);
            },
            [StoreElement.AlarmCategories]
        );
    }
}

export const wtAlarmCategoriesSelector: ComponentDefinition = {
    componentId: 'wtAlarmCategoriesSelector',
    controller: AlarmCategoriesSelector,
    template: require('./alarmCategoriesSelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '=',
        disabled: '<?'
    }
};